import React, { useState, useEffect } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import useVoucher from '../../hooks/useVoucher';
import useCorsi from '../../hooks/useCorsi';
import useUtenti from '../../hooks/useUtenti';
import CustomSearch from '../CustomSearch/CustomSearch';
import { Table, Button, Badge, Card, Form, Alert, Spinner, Accordion } from 'react-bootstrap';
import { alertService } from '../../services/AlertService';
import useMediaQuery from '../../hooks/useMediaQuery';
import VoucherUsageModal from '../VoucherUsageModal/VoucherUsageModal';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';

export default function GestisciVoucherManager({ selectedAgenzia, modalStateVoucher, onHide }) {
   
    const isMobile = useMediaQuery('(max-width: 768px)');
    const userLoggedIn = useSelector(state => state.user.userData);

    const { 
        loadingStateVoucher, createVoucher, deleteVoucher, getVoucherUsage,
        getVoucherByIdAgenzia, getVoucherSummaryByAgenzia,
        getVoucherByIdSuperpartner, getVoucherSummaryBySuperpartner, distributeVoucher
    } = useVoucher();
    
    const { getCorsiByParams } = useCorsi();
    const { getUtenteByParams } = useUtenti();

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [formData, setFormData] = useState({ qt_disponibile: '', data_scadenza: '', note: '' });
    const [voucherList, setVoucherList] = useState([]);
    const [voucherToDelete, setVoucherToDelete] = useState([]);
    const [voucherToAdd, setVoucherToAdd] = useState([]);
    const [voucherSummary, setVoucherSummary] = useState([]);
    const [masterVouchers, setMasterVouchers] = useState([]);
    const [showDistributeFormForVoucher, setShowDistributeFormForVoucher] = useState(null);
    const [distributionFormData, setDistributionFormData] = useState({ quantita_da_distribuire: '', note: '', data_scadenza: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [showUsageModal, setShowUsageModal] = useState(false);
    const [usageData, setUsageData] = useState([]);
    const [isUsageLoading, setIsUsageLoading] = useState(false);
    const [selectedVoucherForUsage, setSelectedVoucherForUsage] = useState(null);
    const [showNoteModal, setShowNoteModal] = useState(false);
    const [noteContent, setNoteContent] = useState('');
    const [entityName, setEntityName] = useState('');

    useEffect(() => {
        if (selectedAgenzia && modalStateVoucher.showModalGestisciVoucher) {
            loadInitialData();
            setEntityName(selectedAgenzia.denominazione || selectedAgenzia.nome);
        }
    }, [selectedAgenzia, modalStateVoucher.showModalGestisciVoucher]);

    /*
    const loadInitialData = async () => {
        setIsLoading(true);
        try {
            let voucherDetails = [];
            let summary = [];

            // Controlliamo se l'oggetto selezionato ha un id_agenzia o un id_superpartner
            if (selectedAgenzia && selectedAgenzia.id_agenzia) {
                
                [voucherDetails, summary] = await Promise.all([
                    getVoucherByIdAgenzia(selectedAgenzia.id_agenzia),
                    getVoucherSummaryByAgenzia(selectedAgenzia.id_agenzia)
                ]);
            } else if (selectedAgenzia && selectedAgenzia.id_superpartner) {
               
                [voucherDetails, summary] = await Promise.all([
                    getVoucherByIdSuperpartner(selectedAgenzia.id_superpartner),
                    getVoucherSummaryBySuperpartner(selectedAgenzia.id_superpartner)
                ]);
            } else {
               
            }

           
            setVoucherList(Array.isArray(voucherDetails) ? voucherDetails : []);
            setVoucherSummary(Array.isArray(summary) ? summary : []);
            setVoucherToAdd([]);
            setVoucherToDelete([]);
            setIsDirty(false);

        } catch (error) {
            
            alertService.error("Si è verificato un errore durante il caricamento dei dati.");
        } finally {
            setIsLoading(false);
        }
    };
*/
  // --- SOSTITUISCI QUESTA INTERA FUNZIONE ---
    const loadInitialData = async () => {
        setIsLoading(true);
        try {
            let voucherDetails = [];
            let summary = [];

            // Carica i dati dell'entità selezionata (Agenzia o Superpartner)
            if (selectedAgenzia.id_agenzia) {
                [voucherDetails, summary] = await Promise.all([
                    getVoucherByIdAgenzia(selectedAgenzia.id_agenzia),
                    getVoucherSummaryByAgenzia(selectedAgenzia.id_agenzia)
                ]);
            } else if (selectedAgenzia.id_superpartner) {
                [voucherDetails, summary] = await Promise.all([
                    getVoucherByIdSuperpartner(selectedAgenzia.id_superpartner),
                    getVoucherSummaryBySuperpartner(selectedAgenzia.id_superpartner)
                ]);
            }
            setVoucherList(Array.isArray(voucherDetails) ? voucherDetails : []);
            setVoucherSummary(Array.isArray(summary) ? summary : []);

            // --- NUOVO BLOCCO ---
            // Se l'utente loggato è un Superpartner, carica anche i suoi pacchetti master
            if (userLoggedIn.role === ROLES.SUPERPARTNER) {
                const masterPacksData = await getVoucherByIdSuperpartner(userLoggedIn.id_superpartner);
                setMasterVouchers(Array.isArray(masterPacksData) ? masterPacksData : []);
            }
            // --- FINE NUOVO BLOCCO ---

            setVoucherToAdd([]);
            setVoucherToDelete([]);
            setIsDirty(false);
        } catch (error) {
            alertService.error("Errore durante il caricamento dei dati.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleShowUsage = async (voucher) => {
        if (voucher.isNew) { alertService.info("Salva le modifiche per visualizzare gli utilizzi."); return; }
        setSelectedVoucherForUsage(voucher);
        setIsUsageLoading(true);
        setShowUsageModal(true);
        try {
            const usageResult = await getVoucherUsage(voucher.id_utenti_voucher);
           
            setUsageData(Array.isArray(usageResult) ? usageResult : (usageResult?.data || []));
        } catch (error) {
            setShowUsageModal(false);
            alertService.error("Errore nel caricamento degli utilizzi.");
        } finally {
            setIsUsageLoading(false);
        }
    };

    const handleCloseUsageModal = () => setShowUsageModal(false);
    const handleShowNoteModal = (voucher) => { setNoteContent(voucher.note); setShowNoteModal(true); };
    const handleSearchCorsi = (params) => getCorsiByParams(params);
    const handleFormChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleAddVoucher = () => {
        if (!selectedCourse || !formData.qt_disponibile || !formData.data_scadenza) {
            alertService.warn("Seleziona un corso, quantità e data di scadenza.", { autoClose: true });
            return;
        }
        // --- NUOVO BLOCCO DI VALIDAZIONE ---
        if (userLoggedIn.role === ROLES.SUPERPARTNER) {
            const pacchettoMaster = masterVouchers.find(v => v.id_corso === selectedCourse.id_corso);
            const rimanenti = (pacchettoMaster?.qt_disponibile || 0) - (pacchettoMaster?.qt_utilizzata || 0);
            const quantitaRichiesta = parseInt(formData.qt_disponibile, 10);

            if (!pacchettoMaster || quantitaRichiesta > rimanenti) {
                alertService.error(`Assegnazione bloccata: puoi distribuire al massimo ${rimanenti} voucher per questo corso.`);
                return;
            }
        }
        // --- FINE BLOCCO DI VALIDAZIONE ---
        const newVoucher = {
            id_corso: selectedCourse.id_corso,
            nome_corso: selectedCourse.denominazione,
            tipo_corso: selectedCourse.tipo_corso,
            qt_disponibile: parseInt(formData.qt_disponibile, 10),
            qt_utilizzata: 0,
            data_scadenza: formData.data_scadenza,
            note: formData.note,
            data_acquisto: new Date().toISOString(),
            esaurito: 0,
            isNew: true
        };
        setVoucherToAdd(prev => [...prev, newVoucher]);
        setIsDirty(true);
        setSelectedCourse(null);
        setFormData({ qt_disponibile: '', data_scadenza: '', note: '' });
    };

    const handleDeleteVoucher = (voucher) => {
        if (voucher.isNew) {
            setVoucherToAdd(prev => prev.filter(v => v.id_corso !== voucher.id_corso));
        } else {
            setVoucherToDelete(prev => [...prev, voucher.id_utenti_voucher]);
            setVoucherList(prev => prev.filter(v => v.id_utenti_voucher !== voucher.id_utenti_voucher));
        }
        setIsDirty(true);
    };

    const handleSave = async () => {
        for (const idVoucher of voucherToDelete) { await deleteVoucher(idVoucher); }
        for (const voucher of voucherToAdd) {
            let dataToSend = {
                id_corso: voucher.id_corso,
                qt_disponibile: voucher.qt_disponibile,
                data_scadenza: voucher.data_scadenza,
                note: voucher.note
            };
            if (selectedAgenzia.id_agenzia) {
                dataToSend.id_agenzia = selectedAgenzia.id_agenzia;
            } else if (selectedAgenzia.id_superpartner) {
                dataToSend.id_superpartner = selectedAgenzia.id_superpartner;
            }
            await createVoucher(dataToSend);
        }
        onHide();
    };

    const renderVoucherStatus = (voucher) => {
        const isExpired = new Date(voucher.data_scadenza) < new Date();
        if (voucher.esaurito) return <Badge bg="danger">Esaurito</Badge>;
        if (isExpired) return <Badge bg="warning" text="dark">Scaduto</Badge>;
        return <Badge bg="success">Attivo</Badge>;
    };

    const renderBody = () => (
        <div className='container-fluid px-0'>
            <Card className="p-3">
                <h6 className="mb-3">Aggiungi nuovo pacchetto voucher</h6>
                <div className='row g-3'>
                    <div className='col-12'>
                        <CustomSearch field={"denominazione"} label={"Cerca corso"} searchApi={handleSearchCorsi} placeholder={"Nome del corso"} selectedItem={selectedCourse} setSelectedItem={setSelectedCourse}/>
                        {selectedCourse && ( <div className='mt-2 p-2 bg-light border rounded'><span><b>Corso:</b> {selectedCourse.denominazione} ({selectedCourse.codice})</span></div> )}
                        {/* --- NUOVO ALERT PER SUPERPARTNER --- */}
                        {userLoggedIn.role === ROLES.SUPERPARTNER && selectedCourse && (
                            <Alert variant="info" className="mt-3">
                                Il tuo pacchetto per questo corso ha una disponibilità residua di: 
                                <strong>
                                    {
                                        (masterVouchers.find(v => v.id_corso === selectedCourse.id_corso)?.qt_disponibile || 0) -
                                        (masterVouchers.find(v => v.id_corso === selectedCourse.id_corso)?.qt_utilizzata || 0)
                                    }
                                </strong> voucher.
                            </Alert>
                        )}
                        {/* --- FINE NUOVO ALERT --- */}
                    </div>
                    <div className='col-12 col-md-6'><Form.Group><Form.Label className="small mb-1"><b>Quantità</b></Form.Label><Form.Control name="qt_disponibile" value={formData.qt_disponibile} onChange={handleFormChange} type="number" /></Form.Group></div>
                    <div className='col-12 col-md-6'><Form.Group><Form.Label className="small mb-1"><b>Scadenza</b></Form.Label><Form.Control name="data_scadenza" value={formData.data_scadenza} onChange={handleFormChange} type="date" /></Form.Group></div>
                    <div className='col-12'><Form.Group><Form.Label className="small mb-1"><b>Note</b></Form.Label><Form.Control as="textarea" rows={2} name="note" value={formData.note} onChange={handleFormChange}/></Form.Group></div>
                    <div className='col-12 text-end'><Button variant="primary" onClick={handleAddVoucher} disabled={!selectedCourse || !formData.qt_disponibile || !formData.data_scadenza}>Aggiungi</Button></div>
                </div>
            </Card>
            <div className="mt-4">
                <h6 className="mb-3">Pacchetti voucher assegnati</h6>
                {isLoading ? <div className="text-center py-3"><Spinner /></div> : [...voucherList, ...voucherToAdd].length > 0 ? (
                     isMobile ? (
                        <div className="d-flex flex-column gap-3">
                            {[...voucherList, ...voucherToAdd].sort((a,b) => new Date(b.data_acquisto) - new Date(a.data_acquisto)).map((v) => (
                                <Card key={v.id_utenti_voucher || v.id_corso} className={v.isNew ? 'border-primary' : ''}>
                                    <Card.Body>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-1">{v.nome_corso}</h6>
                                                <div className="d-flex flex-wrap gap-2 mb-2">
                                                    {renderVoucherStatus(v)}
                                                    <Badge bg="info">Disp: {v.qt_disponibile - (v.qt_utilizzata || 0)}</Badge>
                                                    <Badge bg="dark">Usati: {v.qt_utilizzata || 0}</Badge>
                                                </div>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {(v.qt_utilizzata || 0) > 0 && !v.isNew && (<Button variant="outline-primary" size="sm" onClick={() => handleShowUsage(v)}><i className="bi bi-people-fill me-1"></i> Utilizzi</Button>)}
                                                    <Button variant="outline-info" size="sm" onClick={() => handleShowNoteModal(v)} disabled={!v.note}><i className="bi bi-info-circle-fill me-1"></i> Nota</Button>
                                                </div>
                                            </div>
                                            <Button variant="outline-danger" size="sm" onClick={() => handleDeleteVoucher(v)}><i className="bi bi-trash3"></i></Button>
                                        </div>
                                        <small className="text-muted d-block mt-2">Scade il: {new Date(v.data_scadenza).toLocaleDateString()}</small>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                     ) : (
                        <div className="table-responsive">
                            <Table hover className="align-middle" style={{ tableLayout: 'fixed' }}>
                                <thead className="table-light"><tr><th style={{width: '35%'}}>Corso</th><th>Qt. Disp.</th><th>Qt. Util.</th><th>Scadenza</th><th>Stato</th><th className="text-end">Azioni</th></tr></thead>
                                <tbody>
                                    {[...voucherList, ...voucherToAdd].sort((a,b) => new Date(b.data_acquisto) - new Date(a.data_acquisto)).map((v) => (
                                        <tr key={v.id_utenti_voucher || v.id_corso} className={v.isNew ? 'table-primary' : ''}>
                                            <td style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{v.nome_corso}</td>
                                            <td><Badge bg="info">{v.qt_disponibile}</Badge></td>
                                            <td><Badge bg="dark">{v.qt_utilizzata || 0}</Badge></td>
                                            <td>{new Date(v.data_scadenza).toLocaleDateString()}</td>
                                            <td>{renderVoucherStatus(v)}</td>
                                            <td className="text-end">
                                                <Button variant="outline-info" size="sm" className="me-2" onClick={() => handleShowNoteModal(v)} title="Nota" disabled={!v.note}><i className="bi bi-info-circle-fill"></i></Button>
                                                {(v.qt_utilizzata || 0) > 0 && !v.isNew && ( <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleShowUsage(v)} title="Utilizzi"><i className="bi bi-people-fill"></i></Button> )}
                                                <Button variant="outline-danger" size="sm" onClick={() => handleDeleteVoucher(v)} title="Elimina"><i className="bi bi-trash3"></i></Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                     )
                ) : <p className="text-muted text-center mt-4">Nessun pacchetto voucher assegnato a questa entità.</p>}
            </div>
        </div>
    );
  
    return (
        <>
            <CustomModal
                headerText={`Gestione Voucher - ${entityName}`}
                body={renderBody()}
                show={modalStateVoucher.showModalGestisciVoucher}
                onHide={onHide}
                size="xl"
                onSave={handleSave}
                btnText={"Salva Modifiche"}
                hideSaveBtn={!isDirty}
                onUndoChanges={onHide}
            />
            <VoucherUsageModal show={showUsageModal} onHide={handleCloseUsageModal} isLoading={isUsageLoading} data={usageData} voucher={selectedVoucherForUsage}/>
            <CustomModal show={showNoteModal} onHide={() => setShowNoteModal(false)} onUndoChanges={() => setShowNoteModal(false)} headerText="Nota Voucher" size="md" hideSaveBtn={true} body={<div className="p-3">{noteContent || "Nessuna nota."}</div>}/>
        </>
    );
}